import { Controller } from '@hotwired/stimulus'
import { showToast } from '../lib/toast'
import 'animate.css'
import { Howl } from 'howler'

const badgeSound = new Howl({
  src: ['/badge.wav'],
})

const ANIMATION_ACTIVE = ['animate__animated', 'animate__rubberBand']
const ANIMATION_INACTIVE = ['animate__animated', 'animate__flipOutX']

const BADGE_MESSAGES = {
  1: 'Way to go! You\'ve completed 7 days of meeting your reading goals! Keep going!',
  3: 'Awesome! You\'ve completed 21 days of meeting your reading goals! You\'re almost half way there!',
  5: 'You\'re doing amazing! You\'ve completed 35 days of meeting your reading goals!',
  6: 'You\'re a rockstar! One more week of reading meeting your SRC reading goals!',
  7: 'Congratulations! You\'ve completed meeting your SRC reading goals!',
}

const handleBadgeAnimationEnd = event => {
  const element = event.currentTarget

  element.classList.remove(...ANIMATION_ACTIVE, ...ANIMATION_INACTIVE)
  element.removeEventListener('animationend', handleBadgeAnimationEnd)
}

const setCertificateVisibility = visible => {
  const action = visible ? 'remove' : 'add'

  document.getElementById('certificate-congrats').classList[action]('certificate-hide')
  document.getElementById('badge-caption').classList[action]('certificate-hide')
  document.getElementById('seventh-badge').classList[visible ? 'add' : 'remove']('badge-caption-margin')
}

const badgeNotificationMessage = nextBadgeCount => {
  setCertificateVisibility(nextBadgeCount === 7)
  return BADGE_MESSAGES[nextBadgeCount] || 'Congratulations, you earned a new badge! Keep going!'
}

const applyBadgeAnimation = (element, nextBadgeCount, prevBadgeCount) => {
  let animatedElement

  if (nextBadgeCount > prevBadgeCount) {
    showToast(badgeNotificationMessage(nextBadgeCount), 'success')
    animatedElement = element.children[nextBadgeCount - 1]
    animatedElement.classList.add(...ANIMATION_ACTIVE)
    badgeSound.play()
  }
  else if (prevBadgeCount > nextBadgeCount) {
    Array.from(element.children).forEach(child => {
      child.classList.remove(...ANIMATION_ACTIVE)
    })

    animatedElement = element.children[prevBadgeCount - 1]
    animatedElement.classList.add(...ANIMATION_INACTIVE)
  }

  if (animatedElement) {
    animatedElement.addEventListener('animationend', handleBadgeAnimationEnd)
  }
}

/*
 * This controller is responsible for syncing the badges UI with server state.
 */
export default class extends Controller {
  update() {
    fetch(this.element.dataset.badgesUrl)
      .then(resp => resp.json())
      .then(({ badges }) => {
        const matches = this.element.className.match(/unlocked-([0-9]+)/)

        this.element.className = `badges unlocked-${badges}`

        applyBadgeAnimation(this.element, Number(badges), Number(matches[1]))
      })
  }
}
